// Miky Motorsport - garaz: upgrady, PI vypocet, aplikace na spec (M3)

// Definice upgradu (6 komponent, stupne 0-5)
export const UPGRADES = [
  { id: 'engine', name: 'Motor', desc: 'Vyssi vykon (+vykonova krivka)', baseCost: 2400, max: 5, piPerLevel: 5.0 },
  { id: 'turbo', name: 'Turbo', desc: 'Vice momentu, lepsi spicka', baseCost: 3000, max: 5, piPerLevel: 4.0 },
  { id: 'tires', name: 'Pneumatiky', desc: 'Vyssi grip (podelny i pricny)', baseCost: 2800, max: 5, piPerLevel: 4.5 },
  { id: 'brakes', name: 'Brzdy', desc: 'Silnejsi brzdny moment', baseCost: 1800, max: 5, piPerLevel: 2.0 },
  { id: 'weight', name: 'Odlehčení', desc: 'Nižší hmotnost (lepší vše)', baseCost: 2600, max: 5, piPerLevel: 3.5 },
  { id: 'gearbox', name: 'Převodovka', desc: 'Lepší přenos výkonu', baseCost: 2000, max: 5, piPerLevel: 1.5 },
];

const UPG_BY_ID = Object.fromEntries(UPGRADES.map((u) => [u.id, u]));

// Cena dalsiho stupne (level = aktualni stupen, kupuje se level+1).
// Mirnejsi krivka 1.38^level (driv 1.6) - plne vylepseni 1 auta ~120k misto ~291k,
// aby progrese byla odmenujici a ne grind zed (cil ~10-15 h s rozsirenym obsahem).
export function upgradeCost(id, currentLevel) {
  const u = UPG_BY_ID[id];
  if (!u || currentLevel >= u.max) return null;
  return Math.round(u.baseCost * Math.pow(1.38, currentLevel));
}

// Celkova cena vsech zbyvajicich stupnu (pro "next goal") - pouziva stejnou krivku jako upgradeCost
export function fullUpgradeCost(upgrades) {
  let total = 0;
  for (const u of UPGRADES) {
    const lvl = upgrades[u.id] || 0;
    for (let l = lvl; l < u.max; l++) total += upgradeCost(u.id, l);
  }
  return total;
}

// Performance index z upgradu
export function computePI(spec, upgrades) {
  let pi = spec.basePI ?? 90;
  for (const u of UPGRADES) pi += (upgrades[u.id] || 0) * u.piPerLevel;
  return Math.round(pi);
}

// Trida dle PI (D -> X)
export function piClass(pi) {
  if (pi < 100) return 'D';
  if (pi < 150) return 'C';
  if (pi < 200) return 'B';
  if (pi < 250) return 'A';
  if (pi < 300) return 'S';
  return 'X';
}

// Aplikace upgradu na spec -> novy spec (pro Vehicle / vizual)
export function applyUpgrades(spec, upgrades = {}) {
  const e = upgrades.engine || 0;
  const tu = upgrades.turbo || 0;
  const br = upgrades.brakes || 0;
  const ti = upgrades.tires || 0;
  const w = upgrades.weight || 0;
  const g = upgrades.gearbox || 0;

  const s = structuredClone(spec);
  const eScale = 1 + e * 0.055 + tu * 0.05;
  s.engine.torqueCurve = spec.engine.torqueCurve.map(([rpm, t]) => [rpm, t * eScale]);
  s.engine.redlineRpm = Math.round(spec.engine.redlineRpm * (1 + tu * 0.02));
  s.tire.muLong = spec.tire.muLong * (1 + ti * 0.04);
  s.tire.muLat = spec.tire.muLat * (1 + ti * 0.04);
  s.brakes.maxTorque = Math.round(spec.brakes.maxTorque * (1 + br * 0.08));
  s.chassis.mass = Math.round(spec.chassis.mass * (1 - w * 0.025));
  s.drivetrain.efficiency = Math.min(0.97, spec.drivetrain.efficiency * (1 + g * 0.02));
  return s;
}

// Staty pro garaz UI (0..1 bary relativne k rozumnemu maximu)
export function carStats(spec, upgrades) {
  const a = applyUpgrades(spec, upgrades);
  const peakTorque = Math.max(...a.engine.torqueCurve.map(([, t]) => t));
  return {
    power: clamp01((peakTorque - 150) / 180),
    grip: clamp01((a.tire.muLat - 0.9) / 0.6),
    brakes: clamp01((a.brakes.maxTorque - 1200) / 1400),
    weight: clamp01((1150 - a.chassis.mass) / 350),
  };
}

function clamp01(v) {
  return v < 0 ? 0 : v > 1 ? 1 : v;
}
